var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "modal fade show",
            staticStyle: { display: "block" },
            attrs: {
              id: "go-modal-goover-create-step-3",
              tabindex: "-1",
              "aria-hidden": "true",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog go-modal-goover-create" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "go-text-wrap" }, [
                    _c("div", { staticClass: "modal-title" }, [
                      _vm._v(_vm._s(_vm.$t(_vm.titleModal()))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-icon close",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.$emit("modal:close")
                          },
                        },
                      },
                      [_vm._m(0)]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-block-wrap" }, [
                    _c(
                      "div",
                      { staticClass: "go-modal-inner overflow-y-scroll" },
                      [
                        _c("div", { staticClass: "go-block-body" }, [
                          _c(
                            "div",
                            {
                              staticClass: "go-list-content progress create",
                              staticStyle: {
                                "line-height": "normal",
                                display: "block",
                                height: "100%",
                                "background-color": "transparent",
                              },
                            },
                            [
                              _c("div", { staticClass: "create-answer" }, [
                                _c("p", [
                                  _vm.isLoading === 0
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "go-icon-24 go-spinner custom-go-spinner",
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isLoading === 1
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "go-icon-32 go-icon-check",
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isLoading === 0
                                    ? _c("strong", [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.itemCreateScrapAgent
                                                .briefingTitle
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t(
                                                "scrap-step3.title-process"
                                              )
                                            ) +
                                            "\n                      "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isLoading === 1
                                    ? _c("strong", [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.itemCreateScrapAgent
                                                .briefingTitle
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t(
                                                "scrap-step3.title-complete"
                                              )
                                            ) +
                                            "\n                      "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _vm.isLoading == 2
                                  ? _c("p", [
                                      _vm._m(1),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.itemCreateScrapAgent
                                                .briefingTitle
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t("scrap-step3.title-fail")
                                            ) +
                                            "\n                      "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isLoading == 0
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "scrap-step3.description-process"
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isLoading == 1
                                  ? _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "scrap-step3.description-complete"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.isLoading !== 2
                    ? _c("div", { staticClass: "go-block-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default go-btn-lg",
                            attrs: {
                              type: "button",
                              disabled: _vm.isLoading == 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleGoToAgent()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("scrap-step3.btn-go-to-agent")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-primary go-btn-lg",
                            attrs: {
                              type: "button",
                              disabled: _vm.isLoading == 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("modal:close")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("scrap-agent.confirm")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoading == 2
                    ? _c("div", { staticClass: "go-block-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-primary go-btn-lg",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.handleBackModal(false)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("scrap-agent.back")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal-backdrop fade show" }),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "go-tooltip-area",
        attrs: {
          "data-toggle": "tooltip",
          title: "",
          "data-original-title": "Close",
        },
      },
      [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-icon-wrap fail" }, [
      _c("i", { staticClass: "go-icon-54 go-icon-alert-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }